import React, { useContext, useState } from 'react'
import { VerificationButton } from 'src/components/Global/Button/Button'
import { ForgotWrapper, FormWrapper, PasswordContainer } from './style'
import { InputLogin } from 'src/components/Global/Input/Input'
import { eye } from 'src/assets'
import Select from 'react-select'
import { useDispatch } from 'react-redux'
import { PasswordStrengthIndicator } from 'src/components/Global/PasswordStrength/PasswordStrengthIndicator'
import { useNavigate } from 'react-router'
import { action } from 'typesafe-actions'
import { AuthTypes } from 'src/redux/types/auth'
import { useTypedSelector } from 'src/redux/root-reducer'
import { SnackbarContext } from 'src/contexts/Snack'
import { signUpAction } from 'src/redux/actions/auth'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import useSnackbar from 'src/hooks/useSnackBar'
import { validatePassword } from 'src/components/Validate/validate'
import { FiEye, FiEyeOff } from 'react-icons/fi'
const PasswordForm = () => {
  const navigate = useNavigate()
  const snackbar = useSnackbar()
  const dispatch = useDispatch()
  const [passwordShown, setPasswordShown] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [userData, setUserData] = useState({
    password: '',
  })
  const { password } = userData
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
    dispatch(action(AuthTypes._UPDATE_SIGN_UP_FORM, newData))
  }
  const togglePassword = () => {
    setPasswordShown(!passwordShown)
  }
  const options = [
    { value: 'Facebook', label: 'Facebook' },
    { value: 'Twitter', label: 'Twitter' },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'A friend', label: 'A friend' },
    { value: 'Others', label: 'Others' },
  ]
  const handleOption = (options: any) => {
    console.log(options.value)
  }
  const style = {
    control: (base: any) => ({
      ...base,
      zIndex: 9999,
      backgroundColor: '${({ theme }) => theme.colors.white}',
      border: '1px solid ${({ theme }) => theme.colors.cyanBlue}',
      borderRadius: '5px',
      height: 50,
      minHeight: 50,
      color: '${({ theme }) => theme.colors.CardDark}',
      fontSize: 16,
    }),
  }

  const snackbarCtx: any = useContext(SnackbarContext)
  const { state: snackbarState } = snackbarCtx
  const signUpData: any = useTypedSelector((state) => state.auth.signForm)
  const CreateAccount = (e: any) => {
    e.preventDefault()
    const error: any = validatePassword(userData)
    if (error.error) {
      snackbar.trigger({
        message: error.error.message,
        severity: 'warning',
      })
      return
    }
    if (
      signUpData.phone_number.length === 10 &&
      signUpData.phone_number.charAt(0) !== '0'
    ) {
      let stringNumber = signUpData.phone_number.toString()
      signUpData.phone_number = '0'.concat(stringNumber)
    }
    dispatch(signUpAction({ signUpData, onSuccess, onError }))
    setLoading(true)
  }
  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    setTimeout(() => {
      navigate('/homepage')
    }, 1500)
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Error Creating Your Account',
      severity: 'error',
    })
  }
  return (
    <ForgotWrapper>
      <div className="welcome">
        <h1>Secure your account</h1>
        <p>Enter a secure password</p>
      </div>
      <FormWrapper>
        <div className="each-form">
          <label>Password</label>
          <PasswordContainer>
            <InputLogin
              type={passwordShown ? 'text' : 'password'}
              name="password"
              value={password}
              onChange={handleChange}
            />
            <div onClick={togglePassword} className="img">
              {passwordShown ? <FiEye /> : <FiEyeOff />}
            </div>{' '}
          </PasswordContainer>
          <PasswordStrengthIndicator password={password} />
        </div>
        <div className="each-form">
          <label>Where did you hear about us?</label>
          <Select
            placeholder="Select Option"
            options={options}
            onChange={handleOption}
            styles={style}
            menuPortalTarget={document.body}
          />
        </div>
        <div className="each-form">
          <VerificationButton onClick={CreateAccount}>
            Create Account {loading && <Spinner />}
          </VerificationButton>
        </div>
      </FormWrapper>
    </ForgotWrapper>
  )
}

export { PasswordForm }
